import React from "react";
import styles from "./Loader.less";
export function Loader() {
  return React.createElement("div", {
    className: styles.loader
  }, React.createElement("span", {
    className: styles.bar
  }), React.createElement("span", {
    className: styles.bar
  }), React.createElement("span", {
    className: styles.bar
  }), React.createElement("span", {
    className: styles.bar
  }), React.createElement("span", {
    className: styles.bar
  }));
}